import React, { createContext, useContext, ReactNode, useMemo } from 'react';

interface SiteConfig {
  siteName: string;
  logoPath: string;
  copyright: string;
}

interface SiteContextType {
  siteConfig: SiteConfig;
}

const SiteContext = createContext<SiteContextType | undefined>(undefined);

interface SiteProviderProps {
  children: ReactNode;
}

export const SiteProvider: React.FC<SiteProviderProps> = ({ children }) => {
  const siteConfig = useMemo(() => {
    const hostname = window.location.hostname;
    const isTotoWiki = hostname.includes('ttwiki');
    
    return {
      siteName: isTotoWiki ? '토토위키' : '먹튀위키',
      logoPath: isTotoWiki ? '/images/tt_logo.png' : '/images/mt_logo.png',
      copyright: `© ${new Date().getFullYear()} ${isTotoWiki ? '토토위키' : '먹튀위키'} Community. All rights reserved.`
    };
  }, []);

  return (
    <SiteContext.Provider value={{ siteConfig }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = (): SiteContextType => {
  const context = useContext(SiteContext);
  if (context === undefined) {
    throw new Error('useSite must be used within a SiteProvider');
  }
  return context;
}; 